<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">服务管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠境训练</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">分类管理</span></h2>
      <el-button type="primary" @click="showDialog(false)">新增分类</el-button>
    </div>
    <!-- 全局二维码 -->
    <div class="global-qrcode" v-if="list.length > 0">
      <div class="global-qrcode-title">全局二维码</div>
      <div class="global-qrcode-body">
        <Upload v-model="globalQrUrl" :max-count="1" tip="推荐尺寸 宽 320 × 高 320 px" />
        <div class="global-qrcode-meta">
          <el-tag v-if="globalQrUrl" type="success" size="small">已设置</el-tag>
          <el-tag v-else type="info" size="small">未设置</el-tag>
          <span class="global-qrcode-hint">所有分类共享同一张二维码</span>
        </div>
        <el-button type="primary" size="small" @click="saveGlobalQrCode" :disabled="!globalQrUrl || saving" :loading="saving">保存二维码</el-button>
      </div>
    </div>
    <el-table :data="list" stripe v-loading="loading">
      <el-table-column label="分类名称" prop="name" min-width="200"/>
      <el-table-column label="二维码" width="120"><template #default="{row}"><el-image v-if="row.qrcode_url" :src="row.qrcode_url" style="width:50px;height:50px" fit="contain"/></template></el-table-column>
      <el-table-column label="操作" width="180"><template #default="{row}"><el-button size="small" @click="showDialog(true,row)">编辑</el-button><el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button></template></el-table-column>
    </el-table>
    <el-dialog v-model="dialogVisible" :title="isEdit?'编辑分类':'新增分类'" width="500px">
      <el-form ref="formRef" :model="form" :rules="{name:[{required:true,message:'请输入名称'}]}" label-width="100px">
        <el-form-item label="名称" prop="name"><el-input v-model="form.name"/></el-form-item>
      </el-form>
      <template #footer><el-button @click="dialogVisible=false">取消</el-button><el-button type="primary" @click="handleSave">保存</el-button></template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';import { ElMessage, ElMessageBox } from 'element-plus';import * as api from '../../api/training';import Upload from '../../components/Upload.vue';
const list=ref([]);const loading=ref(false);const dialogVisible=ref(false);const isEdit=ref(false);const formRef=ref(null);const form=ref({name:''});
const globalQrUrl=ref('');const saving=ref(false);
const fetchData=async()=>{loading.value=true;try{const r=await api.getTrainingCategories();list.value=r.data||[];globalQrUrl.value=(list.value[0]?.qrcode_url)||''}catch{}finally{loading.value=false}};
const showDialog=(e,r)=>{isEdit.value=e;form.value=r?{name:r.name}:{name:''};dialogVisible.value=true};
const handleSave=async()=>{const v=await formRef.value.validate().catch(()=>false);if(!v)return;try{if(isEdit.value){await api.updateTrainingCategory(form.value.id,form.value)}else{await api.createTrainingCategory(form.value)}ElMessage.success('保存成功');dialogVisible.value=false;await fetchData()}catch{}};
const saveGlobalQrCode=async()=>{if(!globalQrUrl.value||saving.value)return;saving.value=true;try{await api.updateTrainingQrCode(globalQrUrl.value);ElMessage.success('全局二维码已更新');await fetchData()}catch{ElMessage.error('保存失败')}finally{saving.value=false}};
const handleDelete=(r)=>{ElMessageBox.confirm('确定删除？','提示').then(async()=>{await api.deleteTrainingCategory(r.id);await fetchData()}).catch(()=>{})};
onMounted(fetchData);
</script>
<style scoped>
.header-actions{display:flex;gap:12px;align-items:center}
.global-qrcode{border:1px solid #e4e7ed;border-radius:8px;padding:16px 20px;margin-bottom:20px;background:#fafafa}
.global-qrcode-title{font-weight:600;font-size:15px;margin-bottom:12px;color:#303133}
.global-qrcode-body{display:flex;align-items:center;gap:16px;flex-wrap:wrap}
.global-qrcode-meta{display:flex;align-items:center;gap:8px}
.global-qrcode-hint{font-size:12px;color:#909399}
</style>